module.exports = __webpack_public_path__ + "static/media/logo.8ec4a8b0.svg";